module.exports = __webpack_public_path__ + "static/media/badge-status-active.045c6737.svg";